<template>
  <div class="header position-relative" style="z-index:1000;">
    <dicta-header v-if="!mobile" :englishSupported="false" ref="dictaHeader"></dicta-header>
    <div class="bg-primary position-relative header-wrap">
      <div class="container" :class="[mobile ? 'mobile-header' : 'second-header']">
        <div class="row">
          <div class="col-6 text-white">
            <div class="logo-div" @click="resetData">
              <div class="logo">

                <img class="d-inline" src="../assets/logo.png" alt="Charuzit" />
                <div class="d-inline-block mx-2">{{ hebrew ? 'חרוזית' : 'Charuzit' }}
                  <small class="d-block dicta">DICTA</small>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6" :class="{ 'text-left': hebrew, 'text-right': !hebrew }">
            <mobile-menu v-if="mobile" :englishSupported="false" @showHowDialog="showAbout = true" :howDialog="true">
            </mobile-menu>
            <a v-if="!mobile" id="shortcut-btn" style="cursor:pointer"
              class="text-white m-3 border-bottom pt-1 d-none d-md-inline" @click="showShortcuts = true">
              {{ hebrew ? 'קיצורי מקלדת' : 'Keyboard shortcuts' }}
            </a>
            <b-button v-if="!mobile" variant="primary" class="how-btn btn btn-outline-light btn-primary"
              @click="showAbout = true">
              {{ hebrew ? 'איך זה עובד' : 'How it works' }}
            </b-button>
          </div>
        </div>
      </div>
    </div>
    <keyboard-shortcuts v-model="showShortcuts"></keyboard-shortcuts>
    <about-dialog v-model="showAbout"></about-dialog>
  </div>
</template>
<script>
import AboutDialog from '@/components/HowDialog'
import KeyboardShortcuts from '@/components/KeyboardShortcuts'
export default {
  name: 'Header',
  components: {
    AboutDialog,
    KeyboardShortcuts
  },
  data() {
    return {
      showAbout: false,
      showShortcuts: false
    }
  },
  mounted() {
    // setTimeout(() => { console.log(this.$refs.dictaHeader)  }, 200)
    if (!this.mobile) {
      this.$nextTick(() => {
        this.$watch(
          () => {
            return this.$refs.dictaHeader.menuOpen
          },
          (val) => {
            if (val) {
              if (document.getElementById('word-list').classList.contains('opened')) {
                document.getElementById('word-list').classList.remove('animated')
                document.getElementById('word-list').classList.remove('opened')
                setTimeout(() => { document.getElementById('word-list').classList.add('animated') }, 100)
              }
            }
          }
        )
      })
    }
  },
  methods: {
    resetData() {
      //window.history.replaceState( {} , '', location.href.split("?")[0] )
      //if (this.$route.name !== 'home')
      //  this.$router.push({ name: "home"})
      let currentTab = this.$store.state.searchModel
      this.$store.commit('CLEAR_RESULTS')
      this.$emit('data-cleared')
      this.$store.commit('SET_MODEL', currentTab)
    }
  },
  computed: {
    mobile() {
      return this.$mq === 'xs'
    },
    hebrew() {
      return this.$settings.hebrew
    }
  }
}    
</script>
<style scoped lang="scss">
.header-wrap {
  box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.32);
}

.second-header {
  padding-top: 7px;
  padding-bottom: 7px;
}

.dicta {
  line-height: 14px;
  opacity: .7;
  font-family: 'Arimo';
}

.logo-div {
  font-size: 18px;
  height: 36px;

  img {
    max-width: 36px;
    cursor: pointer;
    vertical-align: top;
  }

  div {
    line-height: 21px;
    cursor: pointer;
  }
}

.mobile-header {
  padding-top: 5px;
  padding-bottom: 5px;

  .mobile-menu {
    padding-top: 6px;
  }

  .logo-div {
    img {
      max-width: 32px;
      margin-top: 2px;
    }
  }
}

.how-btn {
  margin-top: 3px;
}
</style>